import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "./UniversityEvents.css";
import Navbar from "../../components/Navbar";
import axios from "axios";
import Axios from "../../utils/Axios";
import DeleteIcon from "@mui/icons-material/Delete";
import toast, { Toaster } from "react-hot-toast";
import EditIcon from "@mui/icons-material/Edit";
import CircularProgress from "@mui/material/CircularProgress";
import { openToSpeakCountriesMap } from "../../utils/CountriesList";

Modal.setAppElement("#root"); // required for accessibility
export const openToSpeakLocations = openToSpeakCountriesMap;

const UniversityEvents = () => {
  const [events, setEvents] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedEventIdToDelete, setSelectedEventIdToDelete] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [selectedEventIdToUpdate, setSelectedEventIdToUpdate] = useState(null);
  const [isLoadingEvents, setIsLoadingEvents] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const universityOptions = [
    "Harvard University",
    "Stanford University",
    "MIT",
    "Oxford University",
    "IIT Delhi",
    "Delhi University",
  ];
  const timeZoneOptions = [
    { label: "Asia/Kolkata (IST)", value: "IST" },
    { label: "America/New_York (EST)", value: "EST" },
    { label: "Europe/London (GMT)", value: "GMT" },
    { label: "Asia/Tokyo (JST)", value: "JST" },
    { label: "Australia/Sydney (AEST)", value: "AEST" },
    { label: "UTC", value: "UTC" },
  ];
  useEffect(() => {
    getEventData();
  }, []);
  const getEventData = () => {
    setIsLoadingEvents(true);
    axios
      .post(Axios.axiosUrl + Axios.getAllEvents)
      .then((response) => {
        setIsLoadingEvents(false);
        setEvents(response.data);
      })
      .catch((err) => {
        setIsLoadingEvents(false);
        console.error(err);
      });
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [newEvent, setNewEvent] = useState({
    title: "",
    topic: "",
    description: "",
    location: "",
    payment_mode: "",
    date: "",
    start_time: "",
    end_time: "",
    university: "",
    timezone: "",
  });
  const [errors, setErrors] = useState({});

  const openModal = () => {
    setModalIsOpen(true);
    setNewEvent({
      title: "",
      topic: "",
      description: "",
      location: "",
      payment_mode: "",
      date: "",
      start_time: "",
      end_time: "",
      university: "",
      timezone: "",
    });
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setEditMode(false);
    setSelectedEventIdToUpdate(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setNewEvent({ ...newEvent, [name]: value });

    // Clear error as user types
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const saveEvent = async () => {
    const newErrors = {};
    Object.entries(newEvent).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = `${key.replace("_", " ")} is required`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true); // Start loading

    const payload = {
      UNIVERSITY_NAME: newEvent.university,
      LOCATION: newEvent.location,
      TOPIC: newEvent.topic,
      DESCRIPTION: newEvent.description,
      TITLE: newEvent.title,
      PAYMENT_MODE: newEvent.payment_mode,
      START_TIME: newEvent.start_time,
      END_TIME: newEvent.end_time,
      DATE: newEvent.date,
      TIMEZONE: newEvent.timezone,
    };

    try {
      const res = await axios.post(Axios.axiosUrl + Axios.createEvent, payload);
      toast.success("Event Saved Successfully!");
      getEventData();
      closeModal();
      setNewEvent({
        title: "",
        topic: "",
        description: "",
        location: "",
        payment_mode: "",
        date: "",
        start_time: "",
        end_time: "",
        university: "",
        timezone: "",
      });
      setErrors({});
    } catch (err) {
      console.error("Failed to save event:", err);
      toast.error("Failed to save event.");
    } finally {
      setIsSubmitting(false); // End loading
    }
  };

  const updateEvent = async () => {
    setIsSubmitting(true); // Start loading

    const payload = {
      ID: selectedEventIdToUpdate,
      UNIVERSITY_NAME: newEvent.university,
      LOCATION: newEvent.location,
      TOPIC: newEvent.topic,
      DESCRIPTION: newEvent.description,
      TITLE: newEvent.title,
      PAYMENT_MODE: newEvent.payment_mode,
      START_TIME: newEvent.start_time,
      END_TIME: newEvent.end_time,
      DATE: newEvent.date,
      TIMEZONE: newEvent.timezone,
    };

    try {
      const res = await axios.post(Axios.axiosUrl + Axios.updateEvent, payload);
      toast.success("Event Updated Successfully!");
      getEventData();
      closeModal();
      setNewEvent({
        title: "",
        topic: "",
        description: "",
        location: "",
        payment_mode: "",
        date: "",
        start_time: "",
        end_time: "",
        university: "",
        timezone: "",
      });
      setErrors({});
    } catch (err) {
      console.error("Failed to update event:", err);
      toast.error("Failed to update event.");
    } finally {
      setIsSubmitting(false); // End loading
    }
  };

  const confirmDeleteEvent = async () => {
    axios
      .post(`${Axios.axiosUrl + Axios.deleteEvent}`, {
        ID: selectedEventIdToDelete,
      })
      .then((response) => {
        toast.success("Event deleted successfully!");
        setDeleteModalOpen(false);
        setSelectedEventIdToDelete(null);
        getEventData();
      })
      .catch((err) => {
        toast.error("Failed to delete event.");
        console.error(err);
      });
  };

  return (
    <div>
      <Navbar />
      <Toaster
        containerStyle={{
          top: 20,
          left: 20,
          bottom: 20,
          right: 20,
        }}
        gutter={24}
        toastOptions={{
          style: {
            border: "1px solid #grey",
            padding: "16px",
          },
          success: {
            style: {
              opacity: 0.1,
            },
          },
        }}
      />
      <div style={{ padding: "2rem" }}>
        <h2 style={{ color: "#009D7C" }}>University Events</h2>
        <button onClick={openModal} className="add-btn">
          Add Event
        </button>

        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>University</th>
                <th>Title</th>
                <th>Topic</th>
                <th>Description</th>
                <th>Location</th>
                <th>Payment Method</th>
                <th>Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Timezone</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoadingEvents ? (
                <tr>
                  <td
                    colSpan="11"
                    style={{ textAlign: "center", padding: "2rem" }}
                  >
                    <div className="spinner" />
                  </td>
                </tr>
              ) : events.length === 0 ? (
                <tr>
                  <td
                    colSpan="11"
                    style={{ textAlign: "center", padding: "2rem" }}
                  >
                    No events found.
                  </td>
                </tr>
              ) : (
                events.map((event) => (
                  <tr key={event.id}>
                    <td
                      style={{
                        width: 150,
                      }}
                    >
                      {event.UNIVERSITY_NAME}
                    </td>
                    <td
                      style={{
                        width: 100,
                      }}
                    >
                      {event.TITLE}
                    </td>
                    <td
                      style={{
                        width: 200,
                      }}
                    >
                      {event.TOPIC}
                    </td>
                    <td
                      style={{
                        width: 200,
                      }}
                    >
                      {event.DESCRIPTION}
                    </td>
                    <td>{event.LOCATION}</td>
                    <td>{event.PAYMENT_MODE}</td>
                    <td>{new Date(event.DATE).toDateString()}</td>
                    <td>{event.START_TIME}</td>
                    <td>{event.END_TIME}</td>
                    <td>{event.TIMEZONE}</td>
                    <td
                      style={{
                        width: 60,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor: "#1976d2",
                            padding: 5,
                            borderRadius: 50,
                            marginRight: 10,
                          }}
                        >
                          <EditIcon
                            fontSize="10"
                            sx={{
                              color: "#fff",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEditMode(true);
                              setSelectedEventIdToUpdate(event.ID);
                              setNewEvent({
                                title: event.TITLE,
                                topic: event.TOPIC,
                                description: event.DESCRIPTION,
                                location: event.LOCATION,
                                payment_mode: event.PAYMENT_MODE,
                                date: event.DATE?.split("T")[0],
                                start_time: event.START_TIME,
                                end_time: event.END_TIME,
                                university: event.UNIVERSITY_NAME,
                                timezone: event.TIMEZONE || "",
                              });
                              setModalIsOpen(true);
                            }}
                          />
                        </span>
                        <span
                          style={{
                            backgroundColor: "red",
                            padding: 5,
                            borderRadius: 50,
                          }}
                        >
                          <DeleteIcon
                            fontSize="10"
                            sx={{
                              color: "#fff",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedEventIdToDelete(event.ID);
                              setDeleteModalOpen(true);
                            }}
                          />
                        </span>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={{
            content: {
              maxWidth: "500px",
              margin: "auto",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              maxHeight: "90vh",
              zIndex: 9999,
            },
            overlay: {
              zIndex: 9998,
              backgroundColor: "rgba(0,0,0,0.5)",
            },
          }}
        >
          <div className="modal-body">
            <h3> {editMode ? "Update Event" : "Add New Event"} </h3>

            <span className="title-label">University</span>
            <select
              name="university"
              value={newEvent.university}
              onChange={handleChange}
              className="input"
            >
              <option value="">Select University</option>
              {universityOptions.map((uni, index) => (
                <option key={index} value={uni}>
                  {uni}
                </option>
              ))}
            </select>
            {errors.university && (
              <span className="error-msg">{errors.university}</span>
            )}
            <span className="title-label">Title</span>

            <input
              name="title"
              placeholder="Title"
              value={newEvent.title}
              onChange={handleChange}
              className="input"
            />
            {errors.title && <span className="error-msg">{errors.title}</span>}
            <span className="title-label">Topic</span>

            <input
              name="topic"
              placeholder="Topic"
              value={newEvent.topic}
              onChange={handleChange}
              className="input"
            />
            {errors.topic && <span className="error-msg">{errors.topic}</span>}
            <span className="title-label">Description</span>

            <textarea
              name="description"
              placeholder="Description"
              value={newEvent.description}
              onChange={handleChange}
              className="input"
            />
            {errors.description && (
              <span className="error-msg">{errors.description}</span>
            )}
            <span className="title-label">Location</span>

            <select
              name="location"
              value={newEvent.location}
              onChange={handleChange}
              className="input"
            >
              <option value="">Select Location</option>
              {openToSpeakLocations.map((loc, index) => (
                <option key={index} value={loc}>
                  {loc}
                </option>
              ))}
            </select>
            {errors.location && (
              <span className="error-msg">{errors.location}</span>
            )}
            <span className="title-label">Payment Mode</span>

            <input
              name="payment_mode"
              placeholder="Payment Mode"
              value={newEvent.payment_mode}
              onChange={handleChange}
              className="input"
            />
            {errors.payment_mode && (
              <span className="error-msg">{errors.payment_mode}</span>
            )}
            <span className="title-label">Date</span>

            <input
              type="date"
              name="date"
              value={newEvent.date}
              onChange={handleChange}
              className="input"
            />
            {errors.date && <span className="error-msg">{errors.date}</span>}
            <span className="title-label">Start Time</span>

            <input
              type="time"
              name="start_time"
              value={newEvent.start_time}
              onChange={handleChange}
              className="input"
            />
            {errors.start_time && (
              <span className="error-msg">{errors.start_time}</span>
            )}

            <span className="title-label">End Time</span>

            <input
              type="time"
              name="end_time"
              value={newEvent.end_time}
              onChange={handleChange}
              className="input"
            />
            {errors.end_time && (
              <span className="error-msg">{errors.end_time}</span>
            )}
            <span className="title-label">Time Zone</span>
            <select
              name="timezone"
              value={newEvent.timezone}
              onChange={handleChange}
              className="input"
            >
              <option value="">Select Time Zone</option>
              {timeZoneOptions.map((tz, index) => (
                <option key={index} value={tz.value}>
                  {tz.label}
                </option>
              ))}
            </select>
            {errors.timezone && (
              <span className="error-msg">{errors.timezone}</span>
            )}
          </div>

          <div className="modal-footer">
            <button
              onClick={editMode ? updateEvent : saveEvent}
              className="save-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={"small"} />
              ) : editMode ? (
                "Update"
              ) : (
                "Save"
              )}
            </button>
            <button onClick={closeModal} className="cancel-btn">
              Cancel
            </button>
          </div>
        </Modal>
        <Modal
          isOpen={deleteModalOpen}
          onRequestClose={() => setDeleteModalOpen(false)}
          style={{
            content: {
              maxWidth: "400px",
              margin: "auto",
              padding: "20px",
              height: 100,
              borderRadius: "8px",
              textAlign: "center",
            },
            overlay: {
              zIndex: 9998,
              backgroundColor: "rgba(0,0,0,0.5)",
            },
          }}
        >
          <h3>Are you sure you want to delete this event?</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1.5rem",
              gap: "1rem",
            }}
          >
            <button onClick={confirmDeleteEvent} className="delete-btn">
              Delete
            </button>
            <button
              onClick={() => setDeleteModalOpen(false)}
              className="cancel-btn"
            >
              Cancel
            </button>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default UniversityEvents;
